import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { QLeafMapComponent } from './q-leaf-map.component';


@NgModule({
  declarations: [QLeafMapComponent],
  exports: [QLeafMapComponent],
  imports: [
    CommonModule,
    FormsModule,
  ]
})

export class QLeafMapModule { }
